import type { PlcManufacturerCodeLibrary } from "./types";

export const automationdirectCodeLibrary: PlcManufacturerCodeLibrary = {
  manufacturer_id: "automationdirect",
  manufacturer_name: "AutomationDirect",
  codes: [
    {
      id: "ad-bx-e013",
      manufacturer_id: "automationdirect",
      series_id: "ad-brx",
      model: null,
      code: "E013",
      code_type: "I/O Controller Error",
      title_ar: "Internal buffer overflow",
      description_ar: "E013 على BX-EBC100/BX-MBIO يعني حالة Buffer Overflow داخلية.",
      symptoms: ["E013", "الاتصال أو تحديث I/O يتعطل"],
      causes: ["Internal buffer overflow"],
      checks: [
        {
          step: 1,
          action: "سجل الحالة والـconfiguration قبل إعادة التشغيل.",
          expected: "الخطأ ما يتكرر.",
          faulty: "E013 يرجع من جديد.",
        }
      ],
      solutions: ["إذا يتكرر، وثق التكوين وراجع الدعم الفني لأن الدليل يصفه كحالة داخلية يجب الإبلاغ عنها."],
      severity: "عالية",
      source_title: "AutomationDirect BRX User Manual, Chapter 15",
      source_section: "BX-EBC100 and BX-MBIO Error Codes: E013",
      keywords: ["AutomationDirect", "BRX", "E013", "buffer overflow"],
    },
    {
      id: "ad-bx-e119",
      manufacturer_id: "automationdirect",
      series_id: "ad-brx",
      model: null,
      code: "E119",
      code_type: "I/O Controller Error",
      title_ar: "Data not valid",
      description_ar: "E119 يعني أن البيانات غير صالحة؛ ومن أسبابه وجود I/O أكثر من قدرة الـfirmware على المعالجة.",
      symptoms: ["E119", "I/O data غير صالح"],
      causes: ["عدد I/O أكبر من تحمل firmware", "Internal error"],
      checks: [
        {
          step: 1,
          action: "راجع عدد وتكوين موديولات I/O.",
          expected: "التكوين ضمن حدود الجهاز.",
          faulty: "عدد I/O أو التكوين يتجاوز الحدود.",
        }
      ],
      solutions: ["صحح التكوين ضمن الحدود.", "إذا التكوين صحيح والخطأ مستمر، وثق الحالة للدعم."],
      severity: "عالية",
      source_title: "AutomationDirect BRX User Manual, Chapter 15",
      source_section: "BX-EBC100 and BX-MBIO Error Codes: E119 Data not valid",
      keywords: ["AutomationDirect", "BRX", "E119", "data not valid"],
    },
    {
      id: "ad-bx-e126",
      manufacturer_id: "automationdirect",
      series_id: "ad-brx",
      model: null,
      code: "E126",
      code_type: "I/O Controller Error",
      title_ar: "Module is write protected",
      description_ar: "E126 يعني أن الموديول Write Protected؛ ممكن يظهر إذا الموديول مستخدم من Do-more PLC أو DIP switch 5 مفعل.",
      symptoms: ["E126", "الكتابة للإعدادات مرفوضة"],
      causes: ["الموديول مستخدم فعلياً من Do-more PLC", "DIP switch 5 مفعل Write Protect"],
      checks: [
        {
          step: 1,
          action: "راجع حالة استخدام الموديول وDIP switch 5 بعد اتباع تعليمات السلامة.",
          expected: "Write Protect غير مفعل إذا تريد كتابة.",
          faulty: "الموديول يبقى write protected.",
        }
      ],
      solutions: ["ألغِ سبب الحماية فقط إذا التصميم يسمح.", "لا تغيّر DIP switches تحت التغذية إذا الدليل ما يسمح."],
      severity: "تحذير",
      source_title: "AutomationDirect BRX User Manual, Chapter 15",
      source_section: "BX-EBC100 and BX-MBIO Error Codes: E126",
      keywords: ["AutomationDirect", "BRX", "E126", "write protected"],
    },
    {
      id: "ad-bx-e165",
      manufacturer_id: "automationdirect",
      series_id: "ad-brx",
      model: null,
      code: "E165",
      code_type: "I/O Controller Error",
      title_ar: "Module configuration is incorrect",
      description_ar: "E165 يعني أن I/O configuration تغير عن المخزون أو مو صحيح.",
      symptoms: ["E165", "الموديول ما يشتغل بتكوينه المتوقع"],
      causes: ["تحريك Analog Modules أو تغيير التكوين", "Stored configuration ما يطابق الواقع"],
      checks: [
        {
          step: 1,
          action: "قارن الـstored configuration ويا ترتيب الموديولات الحالي.",
          expected: "التكوين مطابق.",
          faulty: "أكو اختلاف بالموديولات أو أماكنها.",
        }
      ],
      solutions: ["أعد كتابة التكوين الصحيح.", "ثبت ترتيب الموديولات حسب المشروع."],
      severity: "عالية",
      source_title: "AutomationDirect BRX User Manual, Chapter 15",
      source_section: "BX-EBC100 and BX-MBIO Error Codes: E165",
      keywords: ["AutomationDirect", "BRX", "E165", "configuration"],
    },  ],
};
